import { render, staticRenderFns } from "./VotingCheckboxCorrespondence.vue?vue&type=template&id=21fa4a16&"
import script from "./VotingCheckboxCorrespondence.vue?vue&type=script&lang=js&"
export * from "./VotingCheckboxCorrespondence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports